<template>
  <VueFinalModal
    :class="classes"
    content-class="ui-modal__content"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
  >
    <UiButtonIconRounded class="ui-modal__close" @click="$emit('close')">
      <IconClose />
    </UiButtonIconRounded>

    <slot></slot>
  </VueFinalModal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { VueFinalModal } from 'vue-final-modal'
import UiButtonIconRounded from './UiButtonIconRounded.vue'
import IconClose from './icons/IconClose.vue'

const props = defineProps<{
  mobileFullScreen?: boolean
}>()

const classes = computed(() => ({
  'ui-modal': true,
  'ui-modal--mobile-full-screen': props.mobileFullScreen,
}))

defineEmits<{
  (e: 'close'): void
}>()
</script>

<style lang="scss">
@import '../styles/config';

.ui-modal {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 2.5rem 0.75rem;
  overflow-y: scroll;
}

.ui-modal__content {
  position: relative;
  max-width: 100%;
  width: 38.75rem;
  margin: auto;
  padding: 1.75rem;
  background-color: $white;
  border-radius: 0.5rem;
  box-shadow: 0.125rem 0.625rem 2rem 0 rgba(0, 0, 0, 0.08);

  @include media-breakpoint-up(md) {
    padding: 3.75rem;
  }
}

.ui-modal__close {
  position: absolute;
  top: 0;
  right: 1.25rem;
  background-color: $white;
  transform: translate(0, -50%);

  svg {
    width: 1rem !important;
    height: 1rem !important;
  }
}

.ui-modal--mobile-full-screen {
  @include media-breakpoint-down(md) {
    &.ui-modal {
      padding: 0;
    }

    .ui-modal__content {
      width: 100%;
      min-height: 100%;
      padding: 3.75rem 0.75rem 1.25rem;
      border-radius: 0;
    }

    .ui-modal__close {
      top: 0.75rem;
      right: 0.75rem;
      transform: none;
    }
  }
}
</style>
